export default __webpack_public_path__ + "static/media/logo-clickHogar-blanco.c2672d31.png";